import { css } from "@emotion/css"

import NumberField from "@p-ban/common/src/components/form/NumberField/NumberField"
import ImageButton from "@p-ban/common/src/components/html/ImageButton"
import Spacer from "@p-ban/common/src/components/layout/Spacer"
import useDebounce from "@p-ban/common/src/hooks/useDebounce"

import FIELD_NAMES from "../../../../constant/fieldNames"
import getDisplayCondition from "../../../../service/getDisplayCondition"
import { isRigid } from "../../../../service/oneClickIs"
import type { OneClickFieldProps } from "../../../../types"
import OneClickField from "../../../components/1Click/form/OneClickField"
import OneClickFieldMessages from "../../../components/1Click/form/OneClickFieldMessages"
import HELP_LINKS from "../../../constant/helpLinks"
import MODAL_ID from "../../../constant/modalId"
import { useModal } from "../../modal/useModal"

import image from "./cnt.png"
import countSimulationButtonImage from "./countSimulationButton.png"
import countSimulationButtonHoverImage from "./countSimulationButton_hover.png"
import massProductionSimulationButtonImage from "./massProductionSimulation.png"
import massProductionSimulationButtonHoverImage from "./massProductionSimulation_hover.png"

const 製造枚数 = ({ values, handlers, errors }: OneClickFieldProps) => {
  const { cnt: shouldShow } = getDisplayCondition(values)

  const onUpdateValue = useDebounce(handlers.number)

  const { open: open枚数シミュレーション } = useModal(MODAL_ID.MULTIPLE_COUNT_SIMULATION)
  const { open: openMassProductionSimulation } = useModal(MODAL_ID.MASS_PRODUCTION_SIMULATION)

  const legend = "製造枚数"

  return (
    <OneClickField isShow={shouldShow} legend={legend} helpURL={HELP_LINKS.製造枚数} src={image}>
      <div className={styles.container}>
        <NumberField
          name={FIELD_NAMES.製造枚数}
          value={values.cnt}
          onUpdateValue={onUpdateValue}
          min={1}
          max={99999}
          maxDecimalDigits={0}
          step={1}
          suffix="枚"
          error={!!errors?.cnt}
          aria-label={legend}
        />
        <Spacer size={105} axis="horizontal" />
        <div className={styles.simulationButton}>
          <ImageButton
            className={styles.button}
            onClick={open枚数シミュレーション}
            src={countSimulationButtonImage}
            hoverSrc={countSimulationButtonHoverImage}
            alt="枚数シミュレーション"
            width={170}
            height={24}
          />
          {isRigid(values) && (
            <>
              <Spacer size={8} />
              <ImageButton
                className={styles.button}
                onClick={openMassProductionSimulation}
                src={massProductionSimulationButtonImage}
                hoverSrc={massProductionSimulationButtonHoverImage}
                alt="量産シミュレーション"
                width={170}
                height={24}
              />
            </>
          )}
        </div>
      </div>
      <OneClickFieldMessages error={errors?.cnt} />
    </OneClickField>
  )
}

export default 製造枚数

const styles = {
  container: css`
    display: flex;
    align-items: center;
  `,
  simulationButton: css`
    display: flex;
    flex-direction: column;
    justify-content: center;
  `,
  button: css`
    height: 24px;
  `,
}
